import type { MemoizedModule } from 'naban/types';

import { NabanApi } from '@izimi/api';
import { createNabanModule } from '@izimi/modules';

export const useNabanModule: MemoizedModule<ReturnType<typeof createNabanModule>> = (
  fetchService,
) => {
  if (!useNabanModule.cache) {
    useNabanModule.cache = createNabanModule({ nabanApi: new NabanApi(fetchService) });
  }
  return useNabanModule.cache;
};
